var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
var cacheParam = urlParams.get('cache');

if(typeof UNIQUE_CACHE_ID !== 'undefined' && UNIQUE_CACHE_ID != null) {
    if(cacheParam != UNIQUE_CACHE_ID) {
        let url = new URL(window.location.href);
        url.searchParams.set("cache", UNIQUE_CACHE_ID);
        window.location.href = url.toString();
    }

    const links = document.querySelectorAll("a");
    for (const link of links) {
        if(link.href.length == 0 || link.href.includes("mailto:") || link.href.includes("tel:")) {
            continue;
        }

        url = new URL(link.href);
        if (url.hostname === window.location.hostname || link.href[0] == "/") {
            url.searchParams.set("cache", UNIQUE_CACHE_ID);
            link.href = url.toString();

            // link.addEventListener("click", function(event, url) {
            // });
        }
    }
} else if(cacheParam) {
    let url = new URL(window.location.href);
    url.searchParams.delete("cache");
    window.location.href = url.toString();
}
